module.exports = __webpack_public_path__ + "img/play-button.565c73ae.png";